/**
 * Interface AgentRepository
 * Clean Architecture - Domain Layer
 * 
 * Définit le contrat pour les implémentations du repository agent
 */

/**
 * @typedef {Object} SendMessageRequest
 * @property {string} message - Message à envoyer
 * @property {Object} [context] - Contexte utilisateur
 * @property {Object} [context.location] - Localisation de l'utilisateur
 * @property {number} context.location.latitude
 * @property {number} context.location.longitude
 * @property {string} [context.location.mode] - Mode de localisation (gps, city, none)
 * @property {Object} [context.preferences] - Préférences utilisateur
 * @property {string[]} [context.preferences.categories]
 * @property {number} [context.preferences.radius]
 * @property {number} [context.timezoneOffset]
 * @property {Object} [context.output]
 * @property {string} [context.output.format]
 * @property {string} [context.platform] - Plateforme (web, mobile)
 */

/**
 * @typedef {Object} SendMessageResponse
 * @property {boolean} success
 * @property {string} message - Message de réponse de l'agent
 * @property {ActionCard[]} actionCards - ActionCards retournées
 * @property {string} [conversationId] - ID de conversation
 * @property {Object} [metadata] - Métadonnées de la réponse
 * @property {number} [metadata.latency] - Latence en ms
 * @property {string[]} [metadata.toolsUsed] - Outils utilisés
 */

/**
 * @typedef {Object} ActionCard
 * @property {'create_suggestion' | 'list' | 'error'} type
 * @property {string} [headline]
 * @property {string} [subheadline]
 * @property {Object} [suggestion]
 * @property {Array} [items]
 * @property {Object} [error]
 */

/**
 * Classe abstraite AgentRepository
 * À implémenter par les repositories concrets (API, Mock)
 */
export class AgentRepository {
  /**
   * Envoie un message à l'agent RASK
   * @param {SendMessageRequest} request - Requête à envoyer
   * @param {string} authToken - Token d'authentification Firebase
   * @returns {Promise<SendMessageResponse>}
   */
  async sendMessage(request, authToken) {
    throw new Error('Method not implemented');
  }

  /**
   * Vérifie la santé du service agent
   * @returns {Promise<{healthy: boolean, timestamp: string}>}
   */
  async checkHealth() {
    throw new Error('Method not implemented');
  }

  /**
   * Récupère les métriques du service (si authentifié)
   * @param {string} authToken - Token d'authentification
   * @returns {Promise<Object>}
   */
  async getMetrics(authToken) {
    throw new Error('Method not implemented');
  }
}

export default AgentRepository;



